import CoachesSection from "../../components/coaches-section";
import FeedbackSection from "../../components/feedback-section";
import Accordion from "../../../components/accordion";
import VideoModal from "../../../components/base/video-modal";
import SectionsTransitions from "../../components/sections-transitions";
import Api from "../../../lib/api";
import {AnalyticsService} from "../../../services/analytics-service";

export default class PageModule {
    constructor() {
        this.initAnalytics();
        this.initHeroSection();
        this.initCoachesSection();
        this.initFeedbackSection();
        this.initFaqSection();
        this.initSectionsTransitions();
    }

    initAnalytics() {
        const $lmsLinks = document.querySelectorAll(`a[href^="${Api.lmsUrl}/join"]`);

        $lmsLinks.forEach(($link) => {
            $link.href = Api.updateUrlWithUtmTagQueryParams($link.href);

            $link.addEventListener('click', (e) => {
                e.preventDefault();
                Api.sendFbEvent('Sprint-Start');
                location.href = $link.href;
            });
        });
    }

    initHeroSection() {
        new VideoModal({ id: 'hero-video' });
    }

    initCoachesSection() {
        new CoachesSection();
    }

    initFeedbackSection() {
        new FeedbackSection();
    }

    initFaqSection() {
        new Accordion('faqAccordion')
    }

    initSectionsTransitions() {
        new SectionsTransitions({
            $sections: [
                document.querySelector('.section.-process'),
                document.querySelector('.section.-intro'),
                document.querySelector('.section.-goals'),
                document.querySelector('.section.-programme'),
                document.querySelector('.section.-profession'),
                document.querySelector('.section.-faq'),
            ]
        });
    }
}